import {forwardRef} from "react";
import {View} from "@unibuddy/patron";
import {ChatFooter} from "@unibuddy/chat-ui";
import {useChat} from "../useChat";
import useAuth from "ubcommunity-shared/src/Auth/hooks/useAuth";
import {ChatInputImproved} from "../ChatInputImproved/ChatInputImproved";

type InputProps = {
    conversationId: string;
};

export const ChatInputWidget = forwardRef<HTMLTextAreaElement, InputProps>(
    ({conversationId}, ref) => {
        const {user} = useAuth();
        const {onSend} = useChat(conversationId, user);

        const handleSend = (text: string) => {
            onSend({text});
        };

        return (
            <View borderTopWidth={1} borderColor="grey100">
                <ChatFooter>
                    <ChatInputImproved ref={ref} onSend={handleSend} />
                </ChatFooter>
            </View>
        );
    },
);
